import React, { useEffect, useRef } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import ActivityLoader from '../../components/Common/ActivityLoader';
import Notification from '../../components/Common/Notification';
import Pagination from '../../components/Common/Pagination';
import ActionDropdownItem from '../../components/Common/PageTitle/ActionDropdownItem';
import printContent from '../../util/araknerdlib';
import functions from '../../util/functions';
import { useFeesBalance } from '../../DataStore/FeesBalanceContext';
import { useTheme } from '../../DataStore/ThemeContext';

const FeesBalancePage = () => {
    const { listing, metaData, setCurrentPage, getFeesBalances, mounted } = useFeesBalance();
    const {openSettings} = useTheme();
    const reportRef = useRef();

    useEffect(() => {
        if(!mounted){
            getFeesBalances();
        }
    }, []);

    const handleSyncBalances = () =>{
        openSettings("Sync Balances", "SyncFeesBalances");
    }


    const PageActions = () => (
        <>
            <ActionDropdownItem iconClass="fa fa-sync text-success" label="Sync Balances" onClick={handleSyncBalances}/>
            <ActionDropdownItem iconClass="fa fa-sync text-primary" label="Refresh" onClick={() => getFeesBalances(true)} />
            <ActionDropdownItem iconClass="fa fa-print text-secondary" label="Print" onClick={() => printContent(reportRef, "Class List")} />
        </>
    );

    return (
        <PageContainer>
            <MainContent>
                <PageTitle
                    title="Fees Balances"
                    description="View and manage student fees balances."
                    iconClass="fa fa-credit-card"
                    sticky={true}
                    PageActions={PageActions}
                    Pagination={metaData ? (
                        <Pagination
                            metaData={metaData}
                            onPageChange={(page) => setCurrentPage(page)}
                            loadMore={true}
                        />
                    ) : null}
                />

                <div ref={reportRef}>
                    <div className="card mb-4">
                        <div className="card-body">
                            {Array.isArray(listing) ? (
                                <table className="table table-striped table-bordered">
                                    <thead className="thead-light">
                                        <tr>
                                            <th>#</th>
                                            <th>Reg. No</th>
                                            <th>Full Name</th>
                                            <th>Gender</th>
                                            <th>Class</th>
                                            <th>Residence</th>
                                            <th>Balance</th>
                                            <th>Last Updated</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listing.map((student, index) => (
                                            <tr key={student.student_id}>
                                                <td>{index + 1}</td>
                                                <td>{student.reg_no}</td>
                                                <td>{student.full_name}</td>
                                                <td>{student.sex}</td>
                                                <td>{student.class?.class_name || '-'}</td>
                                                <td>{student.residence?.residence_name || '-'}</td>
                                                <td>{functions.numberFormat(student.balance)}</td>
                                                <td>{functions.formatDate(student.last_synced)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ) : listing === '404' ? (
                                <Notification type="info" message="No student balance records found." closable={false} />
                            ) : (
                                <ActivityLoader />
                            )}
                        </div>
                    </div>
                </div>
            </MainContent>
        </PageContainer>
    );
};

export default FeesBalancePage;
